function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-image\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16,20.68a5.87,5.87,0,1,1,5.87-5.87A5.88,5.88,0,0,1,16,20.68Zm0-9.49a3.62,3.62,0,1,0,3.62,3.62A3.62,3.62,0,0,0,16,11.19Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.3,30.25a1.12,1.12,0,0,1-.93-.49,1.14,1.14,0,0,1,.3-1.57L8.11,23.8a4.38,4.38,0,0,1,5,0l4.09,2.75A2.17,2.17,0,0,0,20,26.11l5.82-7a4.41,4.41,0,0,1,3.4-1.59h0a4.41,4.41,0,0,1,3.39,1.58l5.92,7.08a1.13,1.13,0,0,1-1.73,1.44l-5.92-7.07a2.14,2.14,0,0,0-1.66-.78h0a2.18,2.18,0,0,0-1.67.78l-5.82,7a4.41,4.41,0,0,1-5.87.85l-4.09-2.75a2.14,2.14,0,0,0-2.43,0L2.94,30.05A1.1,1.1,0,0,1,2.3,30.25Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.44,35.68H6.56a5.43,5.43,0,0,1-5.42-5.42V9.75A5.43,5.43,0,0,1,6.56,4.32H33.44a5.44,5.44,0,0,1,5.43,5.43V30.26A5.44,5.44,0,0,1,33.44,35.68ZM6.56,6.57A3.18,3.18,0,0,0,3.39,9.75V30.26a3.18,3.18,0,0,0,3.17,3.17H33.44a3.19,3.19,0,0,0,3.18-3.17V9.75a3.19,3.19,0,0,0-3.18-3.18Z",
  fill: "#231f20"
});

function SvgCmsImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgCmsImage;